import { render } from "./FunctionGuideVideo.vue?vue&type=template&id=0312d7e6&scoped=true&ts=true"
import script from "./FunctionGuideVideo.vue?vue&type=script&lang=ts"
export * from "./FunctionGuideVideo.vue?vue&type=script&lang=ts"

import "./FunctionGuideVideo.vue?vue&type=style&index=0&id=0312d7e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0312d7e6"]])

export default __exports__